module.exports = new __parcel__URL__("German_Map_DE.7baed562.png").toString();